
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Schlafen wir regelmässig überdurchschnittlich lange, kann das unserem Körper langfristig schaden – so das Fazit mehrerer Studien. Gemäss `}<Link href='https://www.internationaljournalofcardiology.com/article/S0167-5273(16)30010-9/fulltext' mdxType="Link">{`
Wissenschaftern aus Norwegen`}</Link>{`, die die Schlafdauer von fast 400’000 Erwachsenen ausgewertet haben, `}<M mdxType="M">{`erhöhe bereits eine Schlafdauer von über acht Stunden das Risiko, eine Herzerkrankung zu erleiden.`}</M>{` Die Wahrscheinlichkeit eines frühen Herztodes steige so für Langschläfer um 53 Prozent – verglichen mit der Gruppe, die zwischen sechs und acht Stunden schlief. Warum das so ist, konnte allerdings nicht belegt werden. Die Dauer einer optimalen Nachtruhe liege zwischen sieben und acht Stunden, so kommt eine andere `}<Link href='https://academic.oup.com/sleep/article/41/12/zsy182/5096067' mdxType="Link">{`Studie im Fachmagazin «Sleep»`}</Link>{` zum Schluss. Wer länger oder kürzer die Augen schliesse, müsse tagsüber auf einen Grossteil seiner Gehirnleistung verzichten. Generell gilt, dass sowohl Nachtaktive als auch Langschläfer fahriger sprechen und schlechtere Entscheidungen treffen. Fazit: Langschläfer sind so eingeschränkt wie Übermüdete.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;